import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    stroke: "#64748B",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M5.587 5.902a9.7 9.7 0 0 0 1.897 2.673 9.7 9.7 0 0 0 2.674 1.898c.083.04.124.06.177.075a.7.7 0 0 0 .575-.098c.044-.032.082-.07.159-.146.233-.233.35-.35.466-.426a1.33 1.33 0 0 1 1.454 0c.117.076.234.193.467.426l.13.13c.354.354.531.531.627.722.192.378.192.825 0 1.203-.096.19-.273.368-.627.722l-.106.105c-.353.353-.53.53-.77.664-.266.15-.68.258-.985.257-.275-.001-.463-.054-.84-.161a12.7 12.7 0 0 1-5.522-3.25 12.7 12.7 0 0 1-3.249-5.522c-.107-.376-.16-.564-.16-.84-.002-.305.106-.719.255-.985.135-.24.312-.417.665-.77l.105-.105c.354-.354.531-.531.722-.627a1.33 1.33 0 0 1 1.203 0c.19.096.368.273.722.627l.13.13c.233.233.35.35.426.467a1.33 1.33 0 0 1 0 1.454c-.077.117-.193.233-.426.466a1.4 1.4 0 0 0-.146.16.7.7 0 0 0-.098.574c.015.052.035.094.075.177"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#fff",
      d: "M0 0h16v16H0z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }